import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import TextareaGroup from '../TextareaGroup';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';
import LegalInfo from '../Widget/LegalInfo';

import validate from './validations';

import Button from '../../components/Button';
import TwoGroup from '../../components/TwoGroup';

import { LoadingSpinner } from '../../components/LoadingSpinner';

import { copyFor, capitalization } from '../../copy/copy';

import { getCachedFullName } from '../../utils/formCaching/helpers';

const yourNamePlaceholder = () => copyFor('placeholders', 'yourName', 'petition');
const escapedYourNamePlaceholder = () =>
    yourNamePlaceholder().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const DetailsFormContainer = styled.form`
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
`;

const Row = styled.div`
    margin: 0 -0.5em 12px -0.5em;
    transition: opacity 0.6s;

    .label-response {
        @media (min-width: 30em) {
            position: absolute;
            width: 100%;
            bottom: 142px;
            transition: bottom 0.6s;
        }

        &.petition {
            transition: top 0.6s;
            position: absolute;

            @media (min-width: 30em) {
                bottom: auto;
                top: 22%;
            }

            @media (max-width: 30em) {
                width: 100%;
                top: 28%;
            }
        }
    }

    &.focused {
        opacity: 0;

        &.row-wrapper-2 {
            opacity: 1;

            .label-response {
                bottom: calc(100% - 16px);

                &.petition {
                    top: 0;
                }
            }

            textarea {
                height: 200px;
            }
        }
    }
`;

const FullRow = styled.div`
    width: 100%;
    padding: 0 8px;
`;

const InnerCol = styled.div`
    padding: 0 0.5em;
    float: left;

    &:nth-child(1) {
        width: 40%;

        @media (max-width: 30em) {
            width: 100%;
        }
    }

    &:nth-child(2) {
        width: 35%;

        @media (max-width: 30em) {
            width: 50%;
            margin-top: 10px;
        }
    }

    &:nth-child(3) {
        width: 25%;

        @media (max-width: 30em) {
            width: 50%;
            margin-top: 10px;
        }
    }
`;

const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-top: 0.75em;

    > div {
        position: relative;

        @media (max-width: 30em) {
            display: inline-block;
        }

        > div {
            &:first-child {
                @media (max-width: 30em) {
                    position: relative;
                    top: -18px;
                }
            }
        }
    }

    button {
        &.submitButton {
            ${props => (props.isSubmitting ? `text-indent: -99999px;` : '')};

            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
                margin-left: 0.5em;
            }
        }

        &.middleButton {
            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
                margin-right: 0.5em;
            }
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            display: none;
            top: 7px;
            right: 17%;
            margin-right: -16px;
            width: 32px !important;
            height: 32px !important;
            ${props => (props.isSubmitting ? `display: block` : '')};

            @media (max-width: 30em) {
                top: 28px;
                right: 24%;
            }
        }
    }
`;

const LegalInfoWrapper = styled.div`
    flex: 1;

    + button {
        @media (min-width: 30em) {
            margin-right: 1em !important;
        }
    }

    div {
        margin-right: 0;

        &:last-child {
            margin-left: 0;
        }
    }
`;

const FormGroupWrapper = styled.div`
    @media (max-width: 30em) {
        flex: 1;
        display: flex;
        flex-direction: row;
        margin: 0 -1.5em 0 -0.5em !important;

        > div {
            flex: 1;
            display: flex;
            flex-direction: column;
            margin: 0 0.5em;
        }
    }
`;

const DetailsForm = props => (
    <DetailsFormContainer onSubmit={props.handleSubmit} autocomplete="on">
        <Row className="row-wrapper-1">
            <InnerCol>
                <Field
                    name="fullName"
                    component={InputGroup}
                    type="text"
                    label={copyFor(
                        'formFields',
                        'fullName',
                        'petition',
                        capitalization.all
                    )}
                    placeholder={copyFor('placeholders', 'fullName', 'petition')}
                    onBlur={(event, value) =>
                        value != null &&
                        value !== '' &&
                        props.change(
                            'message',
                            props.initialValues.message
                                .replace(RegExp(escapedYourNamePlaceholder(), 'g'), value)
                                .replace(/@localRepresentative/g, props.localRepFullName)
                        )
                    }
                />
            </InnerCol>
            <InnerCol>
                <Field
                    name="email"
                    component={InputGroup}
                    type="email"
                    label={copyFor(
                        'formFields',
                        'emailAddress',
                        'petition',
                        capitalization.all
                    )}
                    placeholder={copyFor('placeholders', 'emailAddress', 'petition')}
                />
            </InnerCol>
            <InnerCol>
                <Field
                    name="postalCode"
                    component={InputGroup}
                    type="text"
                    label={copyFor(
                        'formFields',
                        'postalCode',
                        'petition',
                        capitalization.all
                    )}
                    placeholder={copyFor('placeholders', 'postalCode', 'petition')}
                />
            </InnerCol>
        </Row>
        <Row className="row-wrapper-2">
            <FullRow>
                <Field
                    title="message"
                    name="message"
                    component={TextareaGroup}
                    label={copyFor(
                        'formFields',
                        'message',
                        'petition',
                        capitalization.all
                    )}
                    placeholder={copyFor('placeholders', 'message', 'petition')}
                    class="message-response petition"
                    classLabel="label-response petition"
                    readOnly={true}
                    expandButton={true}
                />
            </FullRow>
        </Row>
        <ButtonGroup isSubmitting={props.isSubmitting}>
            <TwoGroup>
                <LegalInfoWrapper>
                    <FormGroupWrapper>
                        <GetUpdatesCheckbox />
                        <LegalInfo align="mobile-right" />
                    </FormGroupWrapper>
                </LegalInfoWrapper>
                <Button
                    label={copyFor(
                        'buttons',
                        'back',
                        'petition',
                        capitalization.eachWord
                    )}
                    onClick={props.onBackFromRepAction}
                    className="middleButton"
                />
                <Button
                    primary={true}
                    label={copyFor(
                        'buttons',
                        'submit',
                        'petition',
                        capitalization.eachWord
                    )}
                    type="submit"
                    className="submitButton"
                    isSubmitting={props.isSubmitting}
                    disabled={props.invalid}
                />
                <LoadingSpinner />
            </TwoGroup>
        </ButtonGroup>
    </DetailsFormContainer>
);

DetailsForm.propTypes = {
    response: PropTypes.string,
    localRepFullName: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired
};

export default compose(
    connect(state => ({
        initialValues: {
            getUpdates: true,
            fullName: getCachedFullName(state),
            email: state.cachedFormData.email || '',
            postalCode: state.cachedFormData.postalCode || '',
            message: (state.widget.activeAction.textRaw || '')
                .replace(
                    /@localRepresentative/g,
                    state.localRep.localRepData.representative !== undefined
                        ? state.localRep.localRepData.representative[0].fullName
                        : ''
                )
                .replace(/@userFullName/g, yourNamePlaceholder())
        },
        localRepFullName:
            state.localRep.localRepData.representative !== undefined
                ? state.localRep.localRepData.representative[0].fullName
                : ''
    })),
    reduxForm({
        form: 'petitionDetailsForm',
        validate
    })
)(DetailsForm);



// WEBPACK FOOTER //
// ./src/components/Petition/DetailsForm.jsx